import { QueryHookOptions, useLazyQuery } from '@apollo/react-hooks'
import { PROPERTY_SEARCH_QUERY } from 'apollo'

export const usePropertySearchQuery = () => useLazyQuery(PROPERTY_SEARCH_QUERY)
